import { css } from '@emotion/core';
import { fontWeights, typography } from '../../../../styles/typography';
import { colorsPalette } from '../../../../styles/colors';

export const totalWrapper = css({
  textAlign: 'right',
});

export const total = css(typography.effra28, {
  fontWeight: fontWeights.medium,
});

export const totalMessage = css(typography.effra16, {
  color: colorsPalette.grey60,
});

export const discount = css({
  color: colorsPalette.teal,
  marginTop: 4,
});
